const emptyGuruInsightState = {
  isLoading: false,
  error: null,
  insight: null
}

export default emptyGuruInsightState
